import React, { useEffect, useMemo, useState } from "react";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/DataTableContainer';
import { Button } from "reactstrap";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { deleteDepartment, updateDepartment } from "store/actions";
import CreateDepartment from "./CreateDepartment";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import { MdDeleteOutline } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";

const DepartmentTable = ({ List, loading }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false);
  const [editData, setEditData] = useState();
  const [deleteId, setDeleteId] = useState();
  const [confirmAction, setConfirmAction] = useState();
  const [openModal, setOpenModal] = useState();

  const permissions = JSON.parse(localStorage?.getItem('permissions'));

  const hasEditPermission = permissions.some(item => item?.permissionName === "Edit Departments");
  const hasDeletePermission = permissions.some(item => item?.permissionName === "Delete Departments");

  const handleDelete = (departmentId) => {
    dispatch(deleteDepartment(departmentId))
    setDeleteId('')
    setOpenModal(false);
    setConfirmAction(false);
  };

  useEffect(() => {
    if (deleteId && confirmAction) {
      handleDelete(deleteId);
    }
  }, [deleteId, confirmAction])

  const columns = useMemo(
    () => [
      {
        header: 'Department',
        accessorKey: 'departmentName',
        enableColumnFilter: false,
        enableSorting: true,
      },
      ...(hasEditPermission || hasDeletePermission ? [{
        header: 'Actions',
        id: 'actions',
        cell: ({ row }) => {
          const handleEdit = () => {
            const rowData = row.original;
            setEditData(rowData)
            setIsOpen(true);
          };

          return (
            <div className="d-flex gap-2 ">
              {permissions?.map(item => item?.permissionName)?.includes("Edit Departments") && <Button color="primary" onClick={handleEdit} className="mr-2">
                <FaRegEdit size={18} />
              </Button>}
              {permissions?.map(item => item?.permissionName)?.includes("Delete Departments") && <Button
                color="danger"
                onClick={() => { setDeleteId(row?.original?.departmentId); setOpenModal(true); }}
                className="mr-2"
              >
                <MdDeleteOutline size={18} />
              </Button>}
            </div>
          );
        },
      },
      ] : []),
    ],
    []
  );

  const handleSubmit = (data) => {
    dispatch(updateDepartment(data));
  }

  const handleClose = () => {
    setIsOpen(false)
    setEditData('')
  }

  //meta title
  document.title = "Zain Channels";

  return (
    <>
      <ConfirmationModal okText={"Confirm"} onCancel={() => { setDeleteId(''); setOpenModal(false); }} onOk={() => { setConfirmAction(true); }} isVisible={openModal} title="Delete Department" content='Are You Sure You Want to Delete the Department' />
      <CreateDepartment visible={isOpen} initialData={editData} onSubmit={handleSubmit} handleClose={handleClose} />
      <div className="">
        <div className="container-fluid">
          {/* <Breadcrumbs title="Tables" breadcrumbItem="Data Tables" /> */}

          <TableContainer
            loading={loading}
            columns={columns}
            data={List || []}
            isGlobalFilter={true}
            isPagination={true}
            SearchPlaceholder="Search..."
            pagination="pagination"
            docName="Departments"
            paginationWrapper='dataTables_paginate paging_simple_numbers'
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        </div>
      </div>
    </>
  );
}


export default DepartmentTable;